import { Link, Stack } from "@mui/material";
import CopyIconButton from "./CopyIconButton";

export default function CopyLinkRow({ link }) {
  const styles = {
    row: {
      alignItems: "center",
      borderRadius: 0.5,
      px: 0.25,
      transition: "background-color 0.14s",
      "&:hover": { bgcolor: "background.tableBody" },
    },
    linkText: {
      flex: 1,
      minWidth: 0,
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };

  return (
    <Stack direction="row" sx={styles.row}>
      <Link
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
        sx={styles.linkText}
      >
        {link}
      </Link>
      <CopyIconButton value={link} />
    </Stack>
  );
}
